import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

export const starVariants = cva("", {
  defaultVariants: {
    variant: "full",
  },
  variants: {
    variant: {
      empty: "fill-new-beginnings-base opacity-25",
      full: "fill-new-beginnings-base",
    },
  },
});

export type StarVariantProps = VariantProps<typeof starVariants>;
